// Tactical board static configuration.
export const SCHEMES = {
  "4-4-2": [
    { x: 50, y: 92, label: "P", role: "GK" },
    { x: 15, y: 70, label: "2" }, { x: 38, y: 72, label: "5" },
    { x: 62, y: 72, label: "6" }, { x: 85, y: 70, label: "3" },
    { x: 15, y: 45, label: "7" }, { x: 38, y: 48, label: "8" },
    { x: 62, y: 48, label: "10" }, { x: 85, y: 45, label: "11" },
    { x: 38, y: 20, label: "9" }, { x: 62, y: 20, label: "20" },
  ],
  "4-3-3": [
    { x: 50, y: 92, label: "P" },
    { x: 15, y: 70, label: "2" }, { x: 38, y: 72, label: "5" },
    { x: 62, y: 72, label: "6" }, { x: 85, y: 70, label: "3" },
    { x: 30, y: 50, label: "8" }, { x: 50, y: 52, label: "10" }, { x: 70, y: 50, label: "6" },
    { x: 18, y: 22, label: "7" }, { x: 50, y: 18, label: "9" }, { x: 82, y: 22, label: "11" },
  ],
  "3-5-2": [
    { x: 50, y: 92, label: "P" },
    { x: 25, y: 72, label: "5" }, { x: 50, y: 75, label: "4" }, { x: 75, y: 72, label: "6" },
    { x: 12, y: 50, label: "3" }, { x: 32, y: 52, label: "8" }, { x: 50, y: 50, label: "10" },
    { x: 68, y: 52, label: "7" }, { x: 88, y: 50, label: "11" },
    { x: 38, y: 20, label: "9" }, { x: 62, y: 20, label: "20" },
  ],
  "4-2-3-1": [
    { x: 50, y: 92, label: "P" },
    { x: 15, y: 72, label: "2" }, { x: 38, y: 74, label: "5" },
    { x: 62, y: 74, label: "6" }, { x: 85, y: 72, label: "3" },
    { x: 36, y: 56, label: "8" }, { x: 64, y: 56, label: "6" },
    { x: 18, y: 32, label: "7" }, { x: 50, y: 30, label: "10" }, { x: 82, y: 32, label: "11" },
    { x: 50, y: 14, label: "9" },
  ],
  "5-3-2": [
    { x: 50, y: 92, label: "P" },
    { x: 10, y: 70, label: "3" }, { x: 30, y: 75, label: "5" }, { x: 50, y: 78, label: "4" },
    { x: 70, y: 75, label: "6" }, { x: 90, y: 70, label: "2" },
    { x: 30, y: 50, label: "8" }, { x: 50, y: 50, label: "10" }, { x: 70, y: 50, label: "7" },
    { x: 38, y: 22, label: "9" }, { x: 62, y: 22, label: "11" },
  ],
};

export const COLORS = ["#0ea5e9", "#ef4444", "#f59e0b", "#22c55e", "#0f172a", "#ffffff"];
export const DEFAULT_FRAME_DURATION = 2000;

// Tool palette grouped into categories. The `category` field is used by the UI
// to render section headers. `placement: "click"` tools fire on a single click,
// `placement: "drag"` tools require press-and-drag to define a stroke.
export const TOOLS = [
  // --- Navigation / players ---
  { id: "select", label: "Sposta", icon: "MousePointer2", hint: "Trascina i giocatori · doppio-click per rinominare. (S)", shortcut: "S", category: "Pedine" },
  { id: "erase", label: "Cancella", icon: "Eraser", hint: "Clicca pedina o disegno per eliminarli. (E)", shortcut: "E", category: "Pedine" },
  { id: "text", label: "Testo", icon: "Type", hint: "Click sul campo per scrivere annotazione. (T)", shortcut: "T", category: "Pedine" },

  // --- Drawing strokes ---
  { id: "line", label: "Linea", icon: "Minus", hint: "Linea retta. (L)", shortcut: "L", category: "Disegno", placement: "drag" },
  { id: "arrow", label: "Passaggio", icon: "ArrowRight", hint: "Freccia di passaggio (continua). (A)", shortcut: "A", category: "Disegno", placement: "drag" },
  { id: "run_arrow", label: "Corsa", icon: "MoveRight", hint: "Freccia di corsa (tratteggiata). (R)", shortcut: "R", category: "Disegno", placement: "drag" },
  { id: "dribble_arrow", label: "Dribbling", icon: "Activity", hint: "Freccia di dribbling (zigzag). (D)", shortcut: "D", category: "Disegno", placement: "drag" },
  { id: "free", label: "Penna libera", icon: "PenTool", hint: "Disegno a mano libera. (F)", shortcut: "F", category: "Disegno", placement: "drag" },
  { id: "zone", label: "Zona", icon: "Square", hint: "Trascina per disegnare zona evidenziata. (Z)", shortcut: "Z", category: "Disegno", placement: "drag" },

  // --- Equipment (training materials) — single-click placement ---
  { id: "goal", label: "Porta", icon: "Goal", hint: "Aggiungi una porta. (G)", shortcut: "G", category: "Materiali", placement: "click" },
  { id: "mini_goal", label: "Porta piccola", icon: "RectangleHorizontal", hint: "Porta da allenamento. (M)", shortcut: "M", category: "Materiali", placement: "click" },
  { id: "cone", label: "Cono", icon: "Triangle", hint: "Cono singolo. (C)", shortcut: "C", category: "Materiali", placement: "click" },
  { id: "flat_marker", label: "Cinesino", icon: "CircleDot", hint: "Cinesino (disco piatto).", shortcut: "K", category: "Materiali", placement: "click" },
  { id: "ring", label: "Cerchio", icon: "Circle", hint: "Cerchio da agilità.", shortcut: "O", category: "Materiali", placement: "click" },
  { id: "hurdle", label: "Ostacolo", icon: "Slash", hint: "Ostacolino da salto.", shortcut: "H", category: "Materiali", placement: "click" },
  { id: "mannequin", label: "Sagoma", icon: "User", hint: "Sagoma fissa.", shortcut: "I", category: "Materiali", placement: "click" },
  { id: "ladder", label: "Scaletta", icon: "Grid3x3", hint: "Scaletta agilità (rope ladder).", shortcut: "U", category: "Materiali", placement: "click" },
  { id: "ball", label: "Palla", icon: "CircleDashed", hint: "Pallone. (B)", shortcut: "B", category: "Materiali", placement: "click" },
];

export const EQUIPMENT_IDS = ["goal", "mini_goal", "cone", "flat_marker", "ring", "hurdle", "mannequin", "ladder", "ball"];
export const DRAG_TOOLS = ["line", "arrow", "run_arrow", "dribble_arrow", "free", "zone"];

// Pre-defined formation templates exposed to the UI (alias of SCHEMES keys + meta).
export const FORMATION_TEMPLATES = [
  { id: "4-4-2", label: "4-4-2 Classico" },
  { id: "4-3-3", label: "4-3-3 Offensivo" },
  { id: "3-5-2", label: "3-5-2 Centrocampo folto" },
  { id: "4-2-3-1", label: "4-2-3-1 Moderno" },
  { id: "5-3-2", label: "5-3-2 Difensivo" },
];
